<template>
  <Modal
    :id="'cmp-royalty-royalty_account-sidewindow-add_contract_form'"
    @cancelled="onCancel"
  >
    <template slot="header"
      >New Contract For
      {{
        selectedAccountDetails.royalty_account.royalty_account_name
      }}</template
    >

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <TextField
            :id="'contract_name'"
            class="m1 input_box"
            v-bind="textFieldConfig"
            type="text"
            :value="contract_info.contract_name"
            required
            showValidationIcons
            @validated="onValidation"
            :placeholder="$t('contract_name')"
            @valuechanged="onTextFieldValueChange"
          />
          <v-layout row wrap>
            <v-flex xs6>
              <div class="label_box txtov">Physical</div>
              <div>
                <TextField
                  :showValidationIcons="false"
                  :id="'physical_royalty_rate'"
                  class="m1 input_box"
                  v-bind="textFieldConfig"
                  :value="contract_info.physical_royalty_rate"
                  :placeholder="$t('Rate in %')"
                  @valuechanged="onTextFieldValueChange"
                />
              </div>
            </v-flex>
            <v-flex xs6>
              <div class="label_box txtov">Digital</div>
              <div>
                <TextField
                  :showValidationIcons="false"
                  :id="'digital_royalty_rate'"
                  class="m1 input_box"
                  v-bind="textFieldConfig"
                  :value="contract_info.digital_royalty_rate"
                  :placeholder="$t('Rate in %')"
                  @valuechanged="onTextFieldValueChange"
                />
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex class="input_box" xs6>
              <Dropdown
                :showValidationIcons="false"
                :id="'base'"
                class="m2"
                :tabindex="0"
                :options="physicalBaseTV"
                :selected="
                  physicalBaseTV.find(
                    (b) => b.value == contract_info.physical_base
                  )
                "
                :placeholder="$t('base')"
                deselect
                box
                @selectedChange="(b) => onDropdownChange('physical_base', b)"
              ></Dropdown>
            </v-flex>
            <v-flex class="input_box" xs6>
              <Dropdown
                :showValidationIcons="false"
                :id="'base'"
                class="m2"
                :tabindex="1"
                :options="digitalBaseTV"
                :selected="
                  digitalBaseTV.find(
                    (b) => b.value == contract_info.digital_base
                  )
                "
                :placeholder="$t('base')"
                deselect
                box
                @selectedChange="(b) => onDropdownChange('digital_base', b)"
              ></Dropdown>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <div class="label_box txtov">Licensing</div>
              <div>
                <TextField
                  :showValidationIcons="false"
                  :id="'license_royalty_rate'"
                  class="m1 input_box"
                  v-bind="textFieldConfig"
                  :value="contract_info.license_royalty_rate"
                  :placeholder="$t('Rate in %')"
                  @valuechanged="onTextFieldValueChange"
                />
              </div>
            </v-flex>
            <v-flex xs6>
              <div class="label_box txtov">Recoupables(General)</div>
              <div>
                <TextField
                  :showValidationIcons="false"
                  :id="'cost_split_percent'"
                  class="m1 input_box"
                  v-bind="textFieldConfig"
                  :value="contract_info.cost_split_percent"
                  :placeholder="$t('Rate in %')"
                  @valuechanged="onTextFieldValueChange"
                />
              </div>
            </v-flex>
          </v-layout>
        </div>
        <div>
          <h3>Templates</h3>
          <table class="dt-table2 contact-table">
            <!-- <thead class="dt-table2--head">
              <tr class="dt-table2--row">
                <th class="dt-table2--column"></th>
              </tr>
            </thead> -->
            <tbody class="dt-table2--body">
              <tr
                class="dt-table2--row"
                v-for="template in contract_info.contract_templates"
                :key="template.contract_id"
                @click="(e) => onTemplateClick(template)"
              >
                <td class="dt-table2--column">
                  {{ template["template_name"] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <button class="dt-button v3 c5 copy_button" @click.stop="onCopyContract">
        <img src="static/icons/double-plus.svg" class="dt-icon v5 s2" alt />
        <span> Copy Contract</span>
      </button>
    </template>
    <div></div>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button
        :disabled="!isFormValid"
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 s6"
        @click.stop="onOkClick"
      >
        Ok
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import { AccountsService } from "../../services/accounts.service";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { mapActionObject } from "../../../../store/global";
import { accountsRoyaltyActions } from "../../store/accounts/actions";
import { createTV } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";
import SearchList from "@dtplugins/search-list/search-list";
import * as ActionTypes from "../../store/types";
export default {
  components: {
    Modal,
    InputField,
    SearchList,
  },
  props: ["selectedAccountDetails"],
  data() {
    return {
      contract_info: this.get_new_contract_info(),
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },
      validationResult: {},
    };
  },
  mounted() {
    this.fetchContractFormData();
  },
  mixins: [],

  computed: {
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
    believe_special() {
      return this.$store.getters.account.believe_special;
    },
    royalty_account_id: function () {
      return this.$route.params.royalty_account_id;
    },
    physicalBaseTV: function () {
      return createTV(this.contract_info.physical_ro_bases, "label", "value");
    },
    digitalBaseTV: function () {
      return createTV(this.contract_info.digital_ro_bases, "label", "value");
    },
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    fetchContractFormData: async function () {
      const result = await AccountsService.fetchNewContractFormData();
      console.log("result.data", result.data);
      this.contract_info = {
        ...result.data,
        ...this.contract_info,
        // physical_base: result.data.physical_ro_bases,
        // .find(
        //   (r) => r.label === "income"
        // ).value,
        // digital_base: result.data.digital_ro_bases
        // .find(
        //   (r) => r.label === "income"
        // ).value,

        physical_base: result?.data?.physical_ro_bases?.find(
          (e) => e.value === 2
        )?.value,
        digital_base: result?.data?.digital_ro_bases?.find((e) => e.value === 2)
          ?.value,
      };

      // this.contract_info['physical_base'] = this.physicalBaseTV.find(e => e.value === 2);
      // this.contract_info['digital_base'] = this.digitalBaseTV.find(e => e.value === 2)

      console.log("this.contract_info", this.contract_info);
    },

    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onTextFieldValueChange: function (name, value) {
      this.contract_info[name] = value;
    },

    onCopyContract: function () {
      this.onCancel();
      this.$emit("add_click", "copy_contract_form");
    },
    onHarryFoxContract: function () {
      this.onCancel();
      this.$emit("add_click", "harry_fox_contract_form");
    },
    onDropdownChange(name, value) {
      this.contract_info[name] = value.value;
      console.log({
        name,
        value,
        "add-contract-form.vue:259 this.contract_info[name]":
          this.contract_info[name],
      });
    },

    onTemplateClick: async function (template) {
      const resData = await AccountsService.addNewContractFromTemplate({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        contract_name: template.template_name,
        contract_id: template.contract_id,
      });
      AccountsService.get_royalty_account_contracts(
        this.royalty_account_id
      ).then((res) => {
        this[ActionTypes.RoyaltyAccountsContracts.SET.ALL]({
          royalty_account_id: this.royalty_account_id,
          contracts: res.data.contracts || [],
        });
        this.$emit("selected", resData.data.contract.contract_id);
        this.onCancel();
      });
    },
    onOkClick: async function () {
      const res = await AccountsService.addNewContract({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        ...this.contract_info,
      });
      this[ActionTypes.RoyaltyAccountsContracts.SET.ALL]({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        contracts: res.data.contracts || [],
      });
      this.$emit("selected", res.data.contract.contract_id);
      //this.$emit("added", res.data.contracts);
    },
    get_new_contract_info: function () {
      return {
        contract_name: "",
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        physical_royalty_rate: "",
        digital_royalty_rate: "",
        license_royalty_rate: "",
        cost_split_percent: "",
        fix_price: "",
        digital_base: "",
        physical_base: "",
      };
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-royalty_account-sidewindow-add_contract_form {
  .form-group .input_box {
    padding: 2px 5px;
  }
  .form-group .label_box {
    padding: 2px 5px;
    color: rgba(70, 70, 70, 0.77);
  }

  .copy_button {
    margin-top: 20px;
  }
  div {
    h3 {
      padding: 10px 0 10px 2px;
      color: var(--text-accent);
      font-size: 15px;
    }
  }
  .dt-table2 {
    --body-height: 150px;
    --row-height: 28px;
    margin: 0 5px;
    display: flex;
    flex-direction: column;

    &--head {
    }
    th.dt-table2--column {
      text-align: left;
      color: #828282;
      font-weight: 400;
    }
    &--body {
      background: #f8f8f8;

      display: flex;
      flex-direction: column;

      border: 1px solid var(--sprt-5);
      border-radius: 3px;

      .dt-table2--row {
        border-bottom: 1px solid var(--sprt-7);
      }

      max-height: var(--body-height);
      overflow: auto;
    }
    &--row {
      display: flex;
      flex-direction: row;
      padding: 5px;
      margin: 0px 10px;

      min-height: var(--row-height);
      cursor: pointer;

      &:hover {
        background: rgb(235, 235, 235);
      }
    }
    &--column {
      flex: 1;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
